import { getStandardBranchContainer } from '../factory';
import { EN_STANDARD_BRANCH_NAMESPACE, ISymbol } from '../types/interface';
import { EN_SERVICE_PLUGIN_SYMBOL, IServicePluginManager } from './interface';

export class ServicePluginManager implements IServicePluginManager {
  private _namespace = EN_STANDARD_BRANCH_NAMESPACE.SERVICE_PLUGIN;

  public register(symbol: ISymbol, service: any, description?: string): void {
    if (!Object.values(EN_SERVICE_PLUGIN_SYMBOL).includes(symbol)) {
      throw new Error(`${symbol}未识别`);
    }

    getStandardBranchContainer().register({
      namespace: this._namespace,
      symbol,
      description,
      value: service,
    });
  }

  public getPlugins<T = any>(symbol: EN_SERVICE_PLUGIN_SYMBOL): ((params: T) => Function)[] {
    return getStandardBranchContainer()
      .getAllSymbolized(this._namespace, symbol)
      .map((v: any) => v.value.execute.bind(v.value));
  }

  public async execute<I = any, O = any>(symbol: EN_SERVICE_PLUGIN_SYMBOL, input: I): Promise<O[]> {
    return await Promise.all(
      getStandardBranchContainer()
        .getAllSymbolized(this._namespace, symbol)
        .map((v: any) => v.value.execute.bind(v.value)(input))
    );
  }

  public excuteSync<I = any, O = any>(symbol: EN_SERVICE_PLUGIN_SYMBOL, input: I): O[] {
    return getStandardBranchContainer()
      .getAllSymbolized(this._namespace, symbol)
      .map((v: any) => v.value.execute.bind(v.value)(input));
  }
}
